import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contacto-page',
  templateUrl: './contacto-page.component.html',
  styleUrls: ['./contacto-page.component.css']
})
export class ContactoPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
